const NOTIFICATION_BASE_URL = (
  process.env.REACT_APP_NOTIFICATION_SERVICE_URL || 'http://localhost:3006'
).replace(/\/$/, '');

const handleResponse = async (response) => {
  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  if (text.length === 0) {
    if (!response.ok) {
      throw new Error('Error desconocido en el servicio de notificaciones');
    }
    return null;
  }

  let payload;
  try {
    payload = JSON.parse(text);
  } catch {
    payload = { message: text };
  }

  if (!response.ok) {
    const message = payload?.message || 'Error desconocido en el servicio de notificaciones';
    throw new Error(message);
  }

  return payload;
};

export const createLead = (data) =>
  fetch(`${NOTIFICATION_BASE_URL}/leads`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }).then(handleResponse);

const notificationService = {
  createLead,
};

export default notificationService;
